








































import { Component, Vue } from "vue-property-decorator";
import LogoRow from "@/components/LogoRow.vue";
import AppFooter from "@/components/AppFooter.vue";

@Component({
  components: { LogoRow, AppFooter }
})
export default class Contact extends Vue {
  get lang() {
    return this.$store.state.lang.data;
  }
}
